import { SravniOrganizationsSharedOrganizationType } from '../__generated__/news/Api';

export const GROUP_NAME_BY_TYPE = {
  [SravniOrganizationsSharedOrganizationType.Bank]: 'Банки',
  [SravniOrganizationsSharedOrganizationType.Broker]: 'Брокеры',
  [SravniOrganizationsSharedOrganizationType.Insurance]: 'Страховые компании',
  [SravniOrganizationsSharedOrganizationType.Mfo]: 'МФО',
  [SravniOrganizationsSharedOrganizationType.Other]: 'Прочее',
  [SravniOrganizationsSharedOrganizationType.EducationalOrganization]: 'Школы',
  [SravniOrganizationsSharedOrganizationType.Npf]: 'НПФ',
  [SravniOrganizationsSharedOrganizationType.Leasing]: 'Лизинговые компании',
  [SravniOrganizationsSharedOrganizationType.Marketplace]: 'Маркетплейсы',
  [SravniOrganizationsSharedOrganizationType.Bankruptcy]: 'Компании по банкротству',
  [SravniOrganizationsSharedOrganizationType.University]: 'Вузы',
  [SravniOrganizationsSharedOrganizationType.Bookmaker]: 'Букмекеры',
  [SravniOrganizationsSharedOrganizationType.FoodRation]: 'Сервисы готовых рационов',
};

export const MAP_TYPE_TO_URL = {
  [SravniOrganizationsSharedOrganizationType.Bank]: 'bank',
  [SravniOrganizationsSharedOrganizationType.Broker]: 'broker',
  [SravniOrganizationsSharedOrganizationType.Insurance]: 'strakhovaja-kompanija',
  [SravniOrganizationsSharedOrganizationType.Mfo]: 'mfo',
  [SravniOrganizationsSharedOrganizationType.EducationalOrganization]: 'shkola',
  [SravniOrganizationsSharedOrganizationType.Npf]: 'npf',
  [SravniOrganizationsSharedOrganizationType.Leasing]: 'leasing',
  [SravniOrganizationsSharedOrganizationType.Marketplace]: 'marketplace',
  [SravniOrganizationsSharedOrganizationType.Bankruptcy]: 'bankruptcy',
  [SravniOrganizationsSharedOrganizationType.University]: 'university',
  [SravniOrganizationsSharedOrganizationType.Bookmaker]: 'bukmeker',
  [SravniOrganizationsSharedOrganizationType.FoodRation]: 'raciony-kompanii',
};
